import React from 'react';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, makeStyles, Icons } from '~/lib/bn-material-ui';
import navTheme from './nav-styles';
import { useTranslation } from '~/translations';

const useStyles = makeStyles((theme) => {
  return {
    submenu: {
      position: 'fixed',
      paddingTop: navTheme.nav.appBar.minHeight,
      marginLeft: navTheme.nav.menu.width,
      width: navTheme.nav.submenu.width,
      boxShadow: theme.shadows[3],
    },
    submenuSectionTitle: {
      textTransform: 'uppercase',
      '& .MuiTypography-root': {
        color: theme.palette.primary.main,
        fontWeight: 600,
      },
    },
    submenuLink: {
      '& .MuiListItemIcon-root': {
        minWidth: '2em',
      },
      padding: '.15em 1.2em .15em .75em',
    },
    submenuLinkSelected: {
      backgroundColor: theme.palette.gray[20],
      '& .MuiTypography-root': {
        color: theme.palette.primary.main,
        fontWeight: 600,
      },
      '& .MuiListItemIcon-root': {
        color: 'unset',
        '& .MuiSvgIcon-root': {
          transform: 'scale(0.6)',
        },
      },
      '& .MuiListItemText-primary': {
        fontWeight: 700,
      },
    },
    submenuLinkLast: {
      marginBottom: '2em',
    },
  };
});

function Submenu({ links, open }) {
  const styles = useStyles();
  const { t } = useTranslation();
  if (!links?.length) {
    return null;
  }

  const renderedSubmenuLinks = links.map(item => _renderSection({ item, styles, t }));

  return (
    <Drawer
      key={`k-${links.length}`}
      classes={{
        paper: styles.submenu,
      }}
      variant='persistent'
      open={open}>
      <List>
        {renderedSubmenuLinks}
      </List>
    </Drawer>
  );
}

const _renderSection = ({ item, styles, t }) => {
  return [
    ...item.translationKey ? [(
      <ListItem key={item.translationKey} className={styles.submenuSectionTitle}>
        <ListItemText>{t(item.translationKey)}</ListItemText>
      </ListItem>
    )] : [],
    ...item.links.map((link, index) => {
      return _renderNavigationLink({ link, styles, last: item.links.length - 1 === index, t });
    }),
  ];
};

const _renderNavigationLink = ({ link, styles, last, t }) => {
  const selected = window.location.pathname.startsWith(link.href);
  return (
    <ListItemButton
      component='a'
      href={link.href}
      key={link.translationKey}
      className={`${styles.submenuLink} ${
        selected ? styles.submenuLinkSelected : ''
      } ${
        last ? styles.submenuLinkLast : ''
      }`}
    >
      <ListItemIcon>
        {selected ? <Icons.ArrowForwardIosRounded color='primary'/> : null}
      </ListItemIcon>
      <ListItemText primary={t(link.translationKey)} />
    </ListItemButton>
  );
};

export default Submenu;
